module.exports = __webpack_public_path__ + "img/image-techniques.36cdc3fb.svg";